export default function(
    desktopCheckboxes: NodeListOf<HTMLInputElement>,
    mobileCheckboxes: NodeListOf<HTMLInputElement>,
    downloadSelectedButton: NodeListOf<HTMLButtonElement>
): void {
    // Remove required attribute from all checkboxes that are passed in
    const unrequireAllCheckboxes = (checkboxes: NodeListOf<HTMLInputElement>) => {
        checkboxes.forEach(checkbox => {
            checkbox.removeAttribute('required');
        });
    };

    // Add required="true" attribute from all checkboxes that are passed in
    const requireAllCheckboxes = (checkboxes: NodeListOf<HTMLInputElement>) => {
        checkboxes.forEach(checkbox => {
            checkbox.setAttribute('required', 'true');
        });
    };

    const disableDownloadSelectedButton = () => {
        downloadSelectedButton.forEach(btn => {
            btn.classList.add('disabled');
            btn.setAttribute('aria-disabled', 'true');
        });
    };

    const enableDownloadSelectedButton = () => {
        downloadSelectedButton.forEach(btn => {
            btn.classList.remove('disabled');
            btn.removeAttribute('aria-disabled');
        });
    };

    // Check if any of the checkboxes are checked and if not call the requireAllCheckboxes function
    const areAnyCheckboxesChecked = () => {
        let uncheckedSum = 0;
        desktopCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                return;
            } else {
                uncheckedSum++;
            }
        });

        if (uncheckedSum !== desktopCheckboxes.length) {
            return;
        }

        mobileCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                return;
            } else {
                uncheckedSum++;
            }
        });

        if (uncheckedSum === desktopCheckboxes.length + mobileCheckboxes.length) {
            requireAllCheckboxes(desktopCheckboxes);
            requireAllCheckboxes(mobileCheckboxes);
            disableDownloadSelectedButton();
        }
    };

    window.addEventListener('load', () => {
        desktopCheckboxes.forEach((checkbox, index) => {
            checkbox.addEventListener('change', () => {
                // Change desktop image checkboxes when mobile changes and vice versa
                if (checkbox.checked) {
                    mobileCheckboxes[index].checked = true;

                    // Make at least one checkbox unrequired (as at least one is checked)
                    unrequireAllCheckboxes(desktopCheckboxes);
                    unrequireAllCheckboxes(mobileCheckboxes);
                    enableDownloadSelectedButton();
                } else {
                    mobileCheckboxes[index].checked = false;
                    // Check if any checkboxes are checked
                    areAnyCheckboxesChecked();
                }
            });
        });

        mobileCheckboxes.forEach((checkbox, index) => {
            checkbox.addEventListener('change', () => {
                // Change desktop image checkboxes when mobile changes and vice versa
                if (checkbox.checked) {
                    desktopCheckboxes[index].checked = true;
                } else {
                    desktopCheckboxes[index].checked = false;
                }
            });
        });
    });
}
